import * as _ from 'lodash';
import * as React from 'react';
import { IFile } from 'src/model';
import { IGetFileReturnValue } from 'src/model/dto/file-dto';
import { Svg } from '../Svg';

interface IFileItemProps {
  edit: boolean;
  file: IFile;
  fileUrl?: string;
  getFileUrl?: (fileUuid: string) => Promise<IGetFileReturnValue>;
  handleFileDelete: (fileUuid: string) => void;
}

interface IFileItemState {
  fileUrl: string;
}

export class FileItem extends React.Component<IFileItemProps, IFileItemState> {
  constructor(props: IFileItemProps) {
    super(props);
    this.state = {
      fileUrl: this.props.fileUrl ? this.props.fileUrl : '',
    };
  }

  public deleteFile = () => {
    const { file, handleFileDelete } = this.props;
    handleFileDelete(file.uuid);
  };

  public async componentDidMount() {
    const { file, getFileUrl } = this.props;
    if (getFileUrl) {
      const fileUrl = await getFileUrl(file.uuid);
      if (fileUrl) {
        this.setState(fileUrl);
      }
    }
  }

  public render() {
    const { edit, file } = this.props;
    const { fileUrl } = this.state;

    return (
      <div className='position-relative mt-2' style={{ cursor: 'pointer' }}>
        {edit && (
          <Svg
            className='position-absolute float-right'
            width={12}
            height={12}
            fill='dark'
            src='close'
            style={{ right: '20px' }}
            onClick={this.deleteFile}
          />
        )}
        <a
          href={fileUrl}
          target='_blank'
          className='d-flex flex-column align-items-center'
        >
          <Svg width={36} height={36} fill='primary' src='download-file' />
          <span className='text-center dark mt-2'>{file.filename}</span>
        </a>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/shared/Files/FileItem.tsx